import { render, staticRenderFns } from "./HeritageSearch.vue?vue&type=template&id=a541bbf4&"
import script from "./HeritageSearch.vue?vue&type=script&lang=js&"
export * from "./HeritageSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports